import { MercatorCoordinate, type Map as MapLibreMap } from 'maplibre-gl';
import { readGimbalCamera } from './gimbal-camera-adapter';

/** Measure a transverse one-meter ruler at the aim point, independent of the HUD icon. */
export function recordSensorScale(map: MapLibreMap): void {
  const data = map.getCanvas().dataset;
  if (!map.getVerticalFieldOfView || !map.getContainer().dataset.nightHawk) return;
  const center = map.getCenter(), origin = MercatorCoordinate.fromLngLat(center);
  const radians = map.getBearing() * Math.PI / 180, meter = origin.meterInMercatorCoordinateUnits();
  const probe = (sign: number) => new MercatorCoordinate(origin.x + sign * Math.cos(radians) * meter / 2,
    origin.y + sign * Math.sin(radians) * meter / 2).toLngLat();
  const transform = (map as unknown as { _camera?: { transform?: { locationToScreenPoint?:
    (point: ReturnType<typeof probe>, terrain: { getElevationForLngLat: () => number }) => { x: number; y: number } } } })._camera?.transform;
  if (!transform?.locationToScreenPoint) throw new Error('Sensor scale measurement is incompatible with this map engine.');
  const level = { getElevationForLngLat: () => map.getCenterElevation() };
  const left = transform.locationToScreenPoint(probe(-1), level), right = transform.locationToScreenPoint(probe(1), level);
  data.sensorPixelsPerMeter = String(Math.hypot(right.x - left.x, right.y - left.y));
  const camera = readGimbalCamera(map), ground = MercatorCoordinate.fromLngLat(camera.ground);
  const dx = ((ground.x - origin.x + 1.5) % 1) - .5;
  data.sensorSlantMeters = String(Math.hypot(dx / meter, (ground.y - origin.y) / meter, camera.altitude - camera.aim));
}
